module.exports = __webpack_public_path__ + "static/img/03.ce47a17c.png";